<div class="row">
    <div class="box box-widget widget-user header-card">
        <div class="d-flex align-items-lg-center flex-lg-row flex-column">
            <div class="flex-grow-1">
                <h4 class="fs-16 mb-1">Patient Name: <strong>{{dashboardData?.patient_name}}</strong></h4>
                <p class="text-muted mb-0">{{startdate}}</p>
            </div>


            <form action="javascript:void(0);" class="mb-5">
                <div class="row g-3 mb-0 justify-content-end">
                    <div class="col-auto">
                        <button type="button" (click)="openPatientRecord(dashboardData)"
                            class="p-element p-button-sm p-ripple p-button-outlined p-button p-component"><i
                                class="ri-add-circle-line align-middle me-1"></i>
                            Patient View</button>
                    </div>
                    <div class="col-auto" *ngIf="showPsychiatristsfield == true">
                        <button type="button" [disabled]="disablefield" (click)="openPyschoDiagnosticForm()"
                            class="p-element p-button-sm p-ripple p-button-outlined p-button p-component"><i
                                class="ri-add-circle-line align-middle me-1"></i>
                            Record PsychoDiagnostic</button>
                    </div>

                    <div class="col-auto">
                        <button type="button" (click)="openfeedback()" [disabled]="disablefield"
                            class="p-element p-button-sm p-ripple p-button-outlined p-button p-component"><i
                                class="ri-add-circle-line align-middle me-1"></i>
                            Record Feedback</button>
                    </div>

                    <!--end col-->
                    <div class="col-auto">
                        <button type="button" (click)="openActivity()" [disabled]="disablefield"
                            class="p-element p-button-sm p-ripple p-button-outlined p-button p-component"><i
                                class="ri-add-circle-line align-middle me-1"></i>
                            Record Activity</button>
                    </div>

                    <div class="col-auto">
                        <button type="button" (click)="openPsychiatrist()" [disabled]="disablefield"
                            class="p-element p-button-sm p-ripple p-button-outlined p-button p-component"><i
                                class="ri-add-circle-line align-middle me-1"></i>
                            Record Psychiatrist Session</button>
                    </div>

                    <div class="col-auto">
                        <button type="button" (click)="openPsychologist()" [disabled]="disablefield"
                            class="p-element p-button-sm p-ripple p-button-outlined p-button p-component"><i
                                class="ri-add-circle-line align-middle me-1"></i>
                            Record Psychologist Session</button>
                    </div>

                </div>
            </form>
        </div>
    </div>
    <div class="col-12 col-lg-3 col-xl-3">
        <div class="box box-widget widget-user">
            <!-- Add the bg color to the header using any of the bg-* classes -->
            <div class="widget-user-header bg-img bbsr-0 bber-0" style="background-color: #267392;">
                <h6 class="widget-user-username text-white">{{dashboardData?.patient_name}}</h6>
                <h6 class="widget-user-desc text-white">{{dashboardData?.mobile_number}}</h6>
            </div>
            <div class="widget-user-image">
                <!-- <img class="rounded-circle" src="assets/images/user3.jpg" alt="User Avatar"> -->
                <img class="rounded-circle" src="assets/images/hospital-icon/users.svg" alt="User Avatar">
            </div>
            <div class="box-footer">
                <div class="row">
                    <div class="col-sm-6">
                        <div class="description-block">
                            <h5 class="description-header">{{dashboardData?.enrollment_date}}</h5>
                            <span class="description-text">Start Date</span>
                        </div>
                        <!-- /.description-block -->
                    </div>
                    <!-- /.col -->
                    <div class="col-sm-6 be-1 bs-1">
                        <div class="description-block">
                            <h5 class="description-header">{{dashboardData?.due_date}}</h5>
                            <span class="description-text">Due Date</span>
                        </div>
                        <!-- /.description-block -->
                    </div>
                </div>
                <!-- /.row -->

                <div class="row">
                    <div class="col-md-6">
                        <div class="description-block">
                            <span class="description-text">Patient Id</span>
                            <h5 class="description-header">{{dashboardData?.patient_ref_id}}</h5>
                        </div>
                    </div>
                </div>


            </div>
        </div>
    </div>
    <div class="col-12 col-lg-9 col-xl-9">


        <div class="box box-widget widget-user">
            <div class="card-header p-3  align-items-center d-flex">
                <h4 class="card-title mb-0 flex-grow-1">Package Details</h4>
            </div>
            <div class="card-header p-0 border-0 bg-soft-light d-contents">
                <div class="row g-0 py-28 text-center">
                    <div class="col-6 col-sm-3">
                        <div class="p-3 border border-dashed border-start-0">
                            <h5 class="mb-1">
                                <span class="text-success ms-1 fs-13">{{dashboardData?.package_name}}<i
                                        class="ri-arrow-right-up-line ms-1 align-middle"></i></span>
                            </h5>
                            <p class="text-muted mb-0">Plan Type</p>
                        </div>
                    </div>
                    <!--end col-->
                    <div class="col-6 col-sm-3">
                        <div class="p-3 border border-dashed border-start-0">
                            <h5 class="mb-1">
                                <span class="text-success ms-1 fs-13">{{dashboardData?.package_duration}} Days</span>
                            </h5>
                            <p class="text-muted mb-0">Package Duration</p>
                        </div>
                    </div>
                    <div class="col-6 col-sm-3"
                        *ngFor="let service_name of dashboardData?.services_details; let i = index">
                        <div class="p-3 border border-dashed border-start-0">
                            <h5 class="mb-1">
                                <span
                                    class="text-success ms-1 fs-13">{{service_name?.doneCount}}/{{service_name?.frequency}}</span>
                            </h5>
                            <p class="text-muted mb-0">{{service_name.service_name}}</p>
                        </div>
                    </div>

                    <!-- CRT -->
                    <div *ngIf="showCrt"
                        class="col-6 col-sm-3 d-flex align align-items-center justify-content-center switch-crt">
                        <span class="text-success ms-1 fs-13 me-2">CRT</span>
                        <p-inputSwitch [(ngModel)]="isPatientCRT" (ngModelChange)="crtToggleChange()"
                            [disabled]="isPatientCRT"></p-inputSwitch>
                    </div>


                </div>
            </div>
        </div>

    </div>


</div>

<div class="col-12">
    <p-tabView class="notes-tab-section" [(activeIndex)]="activeIndex" (onChange)="onTabChange($event)">
        <p-tabPanel header="Psychiatrist Session Notes">
            <app-sticky-note-section *ngIf="activeIndex === 0"
                [patientRegistration]="dashboardData" 
                [practitionerId]="15"
                [isDashboard]="true"
                sessionType="RPP"
                roleType="Psychiatrist"
                >
            </app-sticky-note-section>
        </p-tabPanel>
        <p-tabPanel header="Psychologist Session Notes">
            <app-sticky-note-section *ngIf="activeIndex === 1"
                [patientRegistration]="dashboardData" 
                [practitionerId]="13"
                [isDashboard]="true"
                sessionType="RPP"
                roleType="Psychologist"
                >
            </app-sticky-note-section>
        </p-tabPanel>
        <p-tabPanel header="Counsellor Session Notes">
            <app-sticky-note-section *ngIf="activeIndex === 2"
                [patientRegistration]="dashboardData" 
                [practitionerId]="16"
                [isDashboard]="true"
                sessionType="RPP"
                roleType="Counsellor"
                >
            </app-sticky-note-section>
        </p-tabPanel>
    </p-tabView>
</div>

<div *ngIf="commentedData?.length > 0" class="col-12 mt-4">
    <app-summary-review-comment 
        [commentedData]="commentedData" 
        (onCommentView)="onCommentView($event)"
        >
    </app-summary-review-comment>
</div>

<div class="box box-widget widget-user my-4">
    <div class="p-4">
        <button *ngIf="!showWearableDataButton" type="button"
        class="p-element p-button-sm p-ripple p-button-outlined p-button p-component" (click)="toggleWearableDialog()">
        <i class="ri-add-circle-line align-middle me-1"></i>
        Connect Wearable
    </button>

    <button *ngIf="showWearableDataButton" type="button"
        class="p-element p-button-sm p-ripple p-button-outlined p-button p-component" (click)="navigateToWearable()">
        <i class="ri-add-circle-line align-middle me-1"></i>
        View Wearable Data
    </button>

    <button type="button" class="p-element p-button-sm p-ripple p-button-outlined p-button p-component ms-4"
        (click)="toggleWearableCommentForm()">
        <i class="ri-add-circle-line align-middle me-1"></i>
        Add/View Wearable Comment
    </button>
    </div>
    

    <div class="mb-4" *ngIf="isWearableCommentForm">
        <div class="row bs-gutter-x px-2">
            <div class="col-4 px-1">
                <div class="wearable-block p-4">
                    <h4 class="mb-4">Add Wearable Comment</h4>
                    <div>
                        <textarea class="mb-3 w-100" [rows]="5" pInputTextarea autoResize="autoResize"
                            [(ngModel)]="newComment"></textarea>
                    </div>
    
                    <div class="form-check mb-4 ps-0">
                        <input class="form-check-input" type="checkbox" id="prospectCheckbox" name="prospectCheckbox"
                            [(ngModel)]="prospectToBuyWearable">
                        <label class="form-check-label" for="prospectCheckbox">Prospect to buy wearable from
                            emoneeds</label>
                    </div>
    
                    <button type="button" class="btn btn-md btn-primary" (click)="saveComment()">
                        <i class="ri-add-circle-line align-middle me-1"></i>
                        Save Comment
                    </button>
                </div>
            </div>
            <div class="col-8 px-1 wearable-block overflow-auto p-4">
                <div *ngIf="patientRemarkData.length">
                    <p-table [value]="patientRemarkData" appendTo="body" [paginator]="true" [rows]="4"
                        [rowsPerPageOptions]="[4,10,20]">
                        <ng-template pTemplate="header">
                            <tr>
                                <th style="width: 350px;">Comment</th>
                                <th>Date</th>
                                <th>Time</th>
                                <th>Role</th>
                                <th>Action</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-remark>
                            <tr>
                                <td>{{remark.remark}}</td>
                                <td>{{remark.date_created | date:'yyyy-MM-dd h:mm a'}}</td>
                                <td>{{remark.date_created | date:'h:mm a'}}</td>
                                <td>{{remark.created_by_role_name}}</td>
                                <td>
                                    <button pButton type="button" icon="pi pi-pencil"
                                        class="p-button-rounded p-button-success p-button-sm me-2"
                                        (click)="editComment(remark)"></button>
                                    <button pButton type="button" icon="pi pi-trash"
                                        class="p-button-rounded p-button-danger p-button-sm"
                                        (click)="deleteComment(remark)"></button>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>

                    <p-dialog [(visible)]="displayEditCommentDialog" header="Edit Comment" [modal]="true"
                        [responsive]="true">

                        <div class="mb-3">
                            <textarea class="form-control" rows="5" [cols]="60"
                                [(ngModel)]="editCommentText"></textarea>
                        </div>
                        <button pButton type="type" label="Submit" class="p-button-success"
                            (click)="saveEditedComment()"></button>
                    </p-dialog>

                    <p-dialog [(visible)]="deleteCommentDialog" header="Delete Comment" [modal]="true"
                        [responsive]="true">

                        <h4>Are you sure you want to delete the comment ?</h4>
                        <h5><q>{{ deleteCommentText }}</q></h5>

                        <button pButton type="type" label="No" class="p-button-danger me-3"
                            (click)="deleteCommentCancel()"></button>

                        <button pButton type="type" label="Yes" class="p-button-success"
                            (click)="deleteCommentConfirm()"></button>
                    </p-dialog>

                </div>
            </div>
        </div>
    </div>

    <div class="mb-4" *ngIf="isAssessmentData">
        <p-table [value]="assessmentData">
            <ng-template pTemplate="header">
                <tr>
                    <th>Serial Number</th>
                    <th>User ID</th>
                    <th>Email ID</th>
                    <th>Initiate Time</th>
                    <th>Assessment Name</th>
                    <th>Status</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-data>
                <tr>
                    <td>{{data.serial_number}}</td>
                    <td>{{data.user_id}}</td>
                    <td>{{data.email_id}}</td>
                    <td>{{data.initiate_time | date: 'short'}}</td>
                    <td>{{data.assessmentName}}</td>
                    <td>{{data.status}}</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="6">No assessment found.</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>

    <p-dialog class="custom-dialog" [header]="'Connect Wearable'" [(visible)]="showWaerableDialog"
        *ngIf="showWaerableDialog" [style]="{ width: '95vw', height: '95vh', background: '#fff' }" modal="true">
        <app-connect-wearables [patientId]="editData.patient_id"
            (appleConnected)="setWearableConnected($event)"></app-connect-wearables>
    </p-dialog>

    <!-- CRT dialogue -->
    <p-dialog [(visible)]="displayCrtDialog" header="CRT Amount" [modal]="true" [responsive]="true">
        <div class="row">
            <div class="col-12 mb-4">
                <input type="number" pInputText id="crtAmount" [(ngModel)]="crtAmount" placeholder="CRT Amount" />
            </div>
            <div class="col-12 mb-4">
                <div class="note">
                    Note: Once CRT is saved, it cannot be reverted.
                </div>
            </div>
        </div>

        <button pButton type="button" (click)="cancelCRT()" label="Cancel" class="me-2"></button>
        <button pButton type="button" (click)="saveCRT()" label="Save"></button>
    </p-dialog>

    <div class="row">
        <div class="col-xl-12">
            <div class="box box-widget widget-user">
                <div class="card-body p-0">
                    <div class="row row-cols-md-3 row-cols-1">
                        <div class="col col-lg border-end">
                            <div class="py-4 px-3">
                                <h5 class="text-muted text-uppercase fs-14">Diagnosis <i
                                        class="ri-arrow-up-circle-line text-success fs-18 float-end align-middle"></i>
                                </h5>
                                <div class="d-flex align-items-center">
                                    <div class="flex-shrink-0">
                                        <i class="pi pi-plus-circle display-6 text-muted"></i>
                                    </div>
                                    <div class="flex-grow-1 ms-3">

                                        <h5 class="mb-0"><span class="counter-value"
                                                *ngFor=" let provisionaldiagnosisandcode of dashboardData?.provisionaldiagnosisandcode"
                                                [pTooltip]="provisionaldiagnosisandcode"
                                                tooltipPosition="top">{{provisionaldiagnosisandcode}} </span></h5>
                                        <h6 class="text-info mt-2"
                                            *ngIf="dashboardData?.otherprovisionaldiagnosisandcode">
                                            Provisional Diagnosis</h6>
                                        <h5 class="mb-0" *ngIf="dashboardData?.otherprovisionaldiagnosisandcode"><span
                                                class="counter-value"
                                                tooltipPosition="top">{{dashboardData?.otherprovisionaldiagnosisandcode}}
                                            </span></h5>
                                        <h6 class="text-info mt-2"
                                            *ngIf="dashboardData?.didotherprovisionaldiagnosisandcode">Differential
                                            Diagnosis</h6>
                                        <h5 class="mb-0" *ngIf="dashboardData?.didotherprovisionaldiagnosisandcode">
                                            <span class="counter-value"
                                                tooltipPosition="top">{{dashboardData?.didotherprovisionaldiagnosisandcode}}
                                            </span>
                                        </h5>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <!-- <div class="col col-lg border-end">
                            <div class="py-4 px-3">
                                <h5 class="text-muted text-uppercase fs-14">Assigned Counselor <i
                                        class="ri-arrow-up-circle-line text-success fs-18 float-end align-middle"></i>
                                </h5>
                                <div class="d-flex align-items-center">
                                    <div class="flex-shrink-0">
                                        <i class="pi pi-user display-6 text-muted"></i>
                                    </div>
                                    <div class="flex-grow-1 ms-3">

                                        <h4 class="mb-0"><span
                                                class="counter-value text-warning">{{dashboardData?.patient_rpp_counsellor_assignment}}</span>
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        </div>end col -->
                        <div class="col col-lg border-end">
                            <div class="mt-3 mt-md-0 py-4 px-3">
                                <h5 class="text-muted text-uppercase fs-14">Assigned Psychologist <i
                                        class="ri-arrow-up-circle-line text-success fs-18 float-end align-middle"></i>
                                </h5>
                                <div class="d-flex align-items-center">
                                    <div class="flex-shrink-0">
                                        <i class="pi pi-user display-6 text-muted"></i>
                                    </div>
                                    <div class="flex-grow-1 ms-3">
                                        <h4 class="mb-0"><span
                                                class="counter-value text-success">{{dashboardData?.patient_rpp_psychologist_assignment}}</span>
                                        </h4>

                                    </div>
                                </div>
                            </div>
                        </div><!-- end col -->
                        <div class="col col-lg border-end">
                            <div class="mt-3 mt-md-0 py-4 px-3">
                                <h5 class="text-muted text-uppercase fs-14">Assigned Psychiatrist <i
                                        class="ri-arrow-down-circle-line text-danger fs-18 float-end align-middle"></i>
                                </h5>
                                <div class="d-flex align-items-center">
                                    <div class="flex-shrink-0">
                                        <i class="pi pi-user display-6 text-muted"></i>
                                    </div>
                                    <div class="flex-grow-1 ms-3">
                                        <h4 class="mb-0"><span
                                                class="counter-value text-info">{{dashboardData?.patient_rpp_psychiatrist_assignment}}</span>
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col col-lg border-end">
                            <div class="py-4 px-3">
                                <h5 class="text-muted text-uppercase fs-14">Assigned Counsellor <i
                                        class="ri-arrow-up-circle-line text-success fs-18 float-end align-middle"></i>
                                </h5>
                                <div class="d-flex align-items-center">
                                    <div class="flex-shrink-0">
                                        <i class="pi pi-user display-6 text-muted"></i>
                                    </div>
                                    <div class="flex-grow-1 ms-3">

                                        <h4 class="mb-0"><span
                                                class="counter-value text-warning">{{dashboardData?.patient_rpp_counsellor_assignment}}</span>
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- end col -->



                    </div><!-- end row -->
                </div><!-- end card body -->
            </div><!-- end card -->
        </div><!-- end col -->
    </div>

    <div class="row">

        <div class="col-lg-6 col-sm-12 col-md-12 d-flex">
            <div class="box box-widget widget-user w-full">
                <div class="card-header pt-3 pb-3">
                    <h5 class="card-title">Early Warning</h5>
                </div>
                <div class="card-content h-fix" *ngIf="dashboardData?.all_ews_signs?.length >0">
                    <div class="flex-grow-1 ms-3"
                        *ngFor="let biological_name of dashboardData?.all_ews_signs; let i = index">
                        <h5 class="mb-1">{{biological_name?.field_name}}</h5>
                        <p class="mb-0"><span class="counter-value"><i class="pi pi-check-circle text"
                                    style="color: slateblue"></i> {{biological_name?.field_value}} <br /></span></p>

                    </div>
                </div>
            </div>
        </div>

        <div class="col-lg-6 col-sm-12 col-md-12 d-flex">
            <div class="box box-widget widget-user w-full">
                <div class="card-header pt-3 pb-3">
                    <h5 class="card-title">Absent / Reschedule Data</h5>
                    <p><b>Total -</b> {{asentReschedule}}</p>
                </div>
                <div class="card-content absent_reschedule">

                    <ng-container class="p-20 pb-10"
                        *ngFor="let absent_reschedule of dashboardData?.absent_reschedule_data; let i = index">
                        <div class="a-r-c mb-5"
                            [class]="{ 'absebtbg': absent_reschedule.slot_status === 0, 'reschedulebg': absent_reschedule.slot_status === 1 }">
                            <p class="mb-1" *ngIf="absent_reschedule.slot_status === 0"><b>Slot Status -</b> Absebt</p>
                            <p class="mb-1" *ngIf="absent_reschedule.slot_status === 1"><b>Slot Status -</b> Reschedule
                            </p>
                            <p class="mb-1"><b>Date</b> - {{absent_reschedule.rpp_date}}</p>
                            <p class="mb-0"><b>Remark - </b> {{absent_reschedule.remarks}}</p>
                        </div>
                    </ng-container>

                </div>
            </div>
        </div>
    </div>

    <div class="bo box-widget widget-user">
        <app-add-offline-assessment
        *ngIf="patientId && dashboardData?.patient_ref_id && dashboardData?.patient_appointment_id && dataService?.userDetails?.user_id && dataService?.userDetails?.display_name && dataService?.userDetails?.hosp_id" 
        [patientId]="patientId"
        [patientRefId]="dashboardData?.patient_ref_id"
        [appointmentId]="dashboardData?.patient_appointment_id"
        [assignedTo]="dataService?.userDetails?.user_id"
        [assignedToName]="dataService?.userDetails?.display_name"
        [hospId]="dataService?.userDetails?.hosp_id"
        (fetchOfflineAssessment)="getPatientOfflineAssessmentReport()"
        ></app-add-offline-assessment>
    </div>

    <div *ngIf="showCrt" class="box box-widget widget-user">
        <h4 class="mb-0 p-4">Online Assessments</h4>
        <form [formGroup]="onlineAssessmentForm" class="p-4">

            <!-- One Row -->
            <div class="form-group row mb-4">

            <!-- Assessment Dropdown -->
            <div class="col-md-4">
                <label for="assessment_id">Assessment Name</label>
                <p-dropdown 
                id="assessment_id" 
                [options]="onlineAssessmentsList" 
                formControlName="assessment_id" 
                placeholder="Select an assessment"
                optionLabel="label"
                optionValue="value"
                [filter]="true"
                filterPlaceholder="Search"
                appendTo="body"
                styleClass="p-dropdown"
                [filterBy]="'label,shortName'">
                </p-dropdown>

                <!-- Validation -->
                <div *ngIf="onlineAssessmentForm.controls['assessment_id'].hasError('required') &&
                            (onlineAssessmentForm.controls['assessment_id'].touched || 
                            onlineAssessmentForm.controls['assessment_id'].dirty)" 
                    class="text-danger">
                Assessment Name is required.
                </div>
            </div>

            <!-- Payment Section -->
            <div class="col-md-2">
                <h4 class="assessment-label">Payment Status</h4>
                <div class="mb-2 d-flex flex-row justify-content-start gap-4">
                <div class="p-field-radiobutton">
                    <p-radioButton 
                    name="paymentStatus" 
                    value="Paid" 
                    formControlName="paymentStatus" 
                    inputId="paid" 
                    class="me-2">
                    </p-radioButton>
                    <label for="paid">Paid</label>
                </div>
                <div class="p-field-radiobutton">
                    <p-radioButton 
                    name="paymentStatus" 
                    value="Unpaid" 
                    formControlName="paymentStatus" 
                    inputId="unpaid" 
                    class="me-2">
                    </p-radioButton>
                    <label for="unpaid">Unpaid</label>
                </div>
                </div>

                <!-- Validation -->
                <div *ngIf="onlineAssessmentForm.controls['paymentStatus'].hasError('required') &&
                            (onlineAssessmentForm.controls['paymentStatus'].touched || 
                            onlineAssessmentForm.controls['paymentStatus'].dirty)" 
                    class="text-danger">
                Payment Status is required.
                </div>
            </div>

                <!-- Payment Amount -->
                <div class="col-md-4">
                    <h4 class="assessment-label">Payment Amount</h4>
                    INR {{ assessmentPaymentAmount }}
                </div>
            </div>

            <!-- Submit Button -->
            <div class="mb-4">
                <button type="submit" 
                        class="btn btn-primary btn-md me-3 waves-effect waves-light"
                        (click)="initiateAssessment()"
                        >
                    Initiate Assessment
                </button>
            </div>
        </form>
    </div>

    
    <div class="box box-widget widget-user">
        <h4 class="mb-0 p-4">Patient Assessment Data</h4>
        <p-tabView>
            <p-tabPanel header="Online Assessment">
                <div class="table-responsive assessment-table mb-4">
                    <p-table [value]="assessmentData">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>S No.</th>
                                <th>Initiate Time</th>
                                <th>Short Name</th>
                                <th>Assessment Name</th>
                                <th>Status</th>
                                <th>Link</th>
                                <th>View</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-data>
                            <tr>
                                <td>{{data.serial_number }}</td>
                                <td>{{data.initiate_time | date: 'dd-MMM-yyyy hh:mm a'}}</td>
                                <td>{{data.shortName}}</td>
                                <td>{{data.assessmentName}}</td>
                                <td>{{data.status}}</td>
                                <td>
                                    <button pButton
                                            *ngIf="data.status === 'Initiated'" 
                                            pRipple 
                                            type="button" 
                                            icon="pi pi-copy" 
                                            class="p-button-rounded p-button-rounded p-button-outlined me-3"  
                                            pTooltip="Copy Assessment Link"
                                            tooltipPosition="top" 
                                            alt="Copy Link"
                                            [cdkCopyToClipboard]="data?.assessment_link"
                                            (click)="copyAssessmentLink()"
                                            >
                                    </button>
                                </td>
                                <td>
                                    <button *ngIf="data?.status === 'Completed'" 
                                            pButton 
                                            pRipple 
                                            type="button" 
                                            icon="pi pi-eye" 
                                            class="p-button-rounded p-button-rounded p-button-outlined me-3"
                                            (click)="viewAssessmentScore(data)"
                                            >
                                    </button>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td colspan="3">No assessment found.</td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </p-tabPanel>
            <p-tabPanel header="Offline Assessments">
                <div class="table-responsive assessment-table mb-4">
                    <p-table [value]="offlineAssessmentData">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>Name</th>
                                <th>Short Name</th>
                                <th>Date</th>
                                <th>Recommended By</th>
                                <th>Role</th>
                                <th>Conducted By</th>
                                <th>Role</th>
                                <th>Report</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-data>
                            <tr>
                                <td>{{data.assessment_name}}</td>
                                <td>{{data.assessment_shortname}}</td>
                                <td>{{data.assessment_date | date: 'short'}}</td>
                                
                                <td>{{data.recommended_by}}</td>
                                <td>{{data.recommended_by_role}}</td>
                                <td>{{data.conducted_by}}</td>
                                <td>{{data.conducted_by_role}}</td>
                                <td>
                                    <button pButton type="button" icon="pi pi-file-pdf" class="p-button-sm p-button-text"
                                        style="font-size: 3em;" (click)="downloadOfflineAssessmentPortal(data)"></button>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td colspan="3">No assessment found.</td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </p-tabPanel>
        </p-tabView>
    </div>

    <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12">

            <div class="col-xl-12 col-12">

                <div class="row">
                    <div class="col-xl-6 col-12" *ngIf="showActivityGraph">
                        <div class="box">
                            <div class="box-header p-2">
                                <h4 class="box-title">Activity Graph</h4>
                                <div class="pull-right">
                                    <div>
                                        <button pButton type="button" label="D" class="p-button-sm p-button-text me-2"
                                            (click)="getGraphActivityData()"
                                            [ngClass]="{ 'highlighted': sBtn === 1}"></button>
                                        <button pButton type="button" label="W" class="p-button-sm p-button-text me-2"
                                            (click)="showActivityMonthWeekgraph(1)"
                                            [ngClass]="{ 'highlighted': sBtn === 2}"></button>
                                        <button pButton type="button" label="M" class="p-button-sm p-button-text me-2"
                                            (click)="showActivityMonthWeekgraph(2)"
                                            [ngClass]="{ 'highlighted': sBtn === 3}"></button>

                                    </div>
                                </div>
                            </div>
                            <div class="box-body">
                                <p-chart type="bar" [data]="basic1Data" [options]="basicOptions"></p-chart>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-6 col-12" *ngIf="showFeedbackGraph">
                        <div class="box">
                            <div class="box-header p-2">
                                <h4 class="box-title">Feedback Graph</h4>
                                <div class="pull-right">
                                    <div>
                                        <button pButton type="button" label="D" class="p-button-sm p-button-text me-2"
                                            (click)="getGraphFeedbackData()"
                                            [ngClass]="{ 'highlighted': selectBtn === 1}"></button>
                                        <button pButton type="button" label="W" class="p-button-sm p-button-text me-2"
                                            (click)="showFeedbackMonthlWeekGraph(1)"
                                            [ngClass]="{ 'highlighted': selectBtn === 2}"></button>
                                        <button pButton type="button" label="M" class="p-button-sm p-button-text me-2"
                                            (click)="showFeedbackMonthlWeekGraph(2)"
                                            [ngClass]="{ 'highlighted': selectBtn === 3}"></button>

                                    </div>
                                </div>
                            </div>
                            <div class="box-body">
                                <p-chart type="bar" [data]="basicData" [options]="basicOptions"></p-chart>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-6 col-12" *ngIf="showPsychotherapyGraph">
                        <div class="box">
                            <div class="box-header p-2">
                                <h4 class="box-title">Psycotherapy Graph</h4>
                                <div class="pull-right">
                                    <div>
                                        <button pButton type="button" label="D" class="p-button-sm p-button-text me-2"
                                            (click)="getGraphPsycotherapyData()"
                                            [ngClass]="{ 'highlighted': selectButton === 1 }"></button>
                                        <button pButton type="button" label="W" class="p-button-sm p-button-text me-2"
                                            (click)="showmonthlyweekPsycotherapygraph(1)"
                                            [ngClass]="{ 'highlighted': selectButton === 2 }"></button>
                                        <button pButton type="button" label="M" class="p-button-sm p-button-text me-2"
                                            (click)="showmonthlyweekPsycotherapygraph(2)"
                                            [ngClass]="{ 'highlighted': selectButton === 3 }"></button>

                                    </div>
                                </div>
                            </div>
                            <div class="box-body">
                                <p-chart type="bar" [data]="basic3Data" [options]="basicOptions"></p-chart>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-6 col-12" *ngIf="showPharmacotherapyGraph">
                        <div class="box">
                            <div class="box-header p-2">
                                <h4 class="box-title">Pharmacotherapy Graph</h4>
                                <div class="pull-right">
                                    <div>
                                        <button pButton type="button" label="D" class="p-button-sm p-button-text me-2"
                                            (click)="getGraphPharmacotherapyData()"
                                            [ngClass]="{ 'highlighted': selectedButton === 1 }"></button>
                                        <button pButton type="button" label="W" class="p-button-sm p-button-text me-2"
                                            (click)="showmonthlyweekPharmacotherapygraph(1)"
                                            [ngClass]="{ 'highlighted': selectedButton === 2 }"></button>
                                        <button pButton type="button" label="M" class="p-button-sm p-button-text me-2"
                                            (click)="showmonthlyweekPharmacotherapygraph(2)"
                                            [ngClass]="{ 'highlighted': selectedButton === 3 }"></button>
                                    </div>
                                </div>
                            </div>
                            <div class="box-body">

                                <p-chart type="bar" [data]="basic2Data" [options]="basicOptions"></p-chart>

                            </div>
                        </div>
                    </div>
                    <div class="col-xl-12 col-12">
                        <div class="box">
                            <div class="box-header p-2">
                                <h4 class="box-title">Video Recording of {{dashboardData?.patient_name}}</h4>
                            </div>
                            <div class="box-body">
                                <app-video-recording></app-video-recording>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <p-dialog header="Commented By Clinician" 
          [(visible)]="isComment" 
          [modal]="true" 
          [style]="{width: '30vw'}" 
          [baseZIndex]="10000"
          [draggable]="false" 
          [resizable]="false"
          >
        <p>
            {{ selectedCommentedData?.comment }}
        </p>
</p-dialog>


    <p-toast></p-toast>

<!-- <p-dialog [(visible)]="dialogVisible" header="Assessment Result" [modal]="true" [style]="{width: '80vw'}">
  <ng-container>
    <div *ngIf="isIframeLoading" class="d-flex flex-column align-items-center justify-content-center assessment-spinnner-block">
      <div class="spinner-border text-primary mb-3" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="text-muted">Loading result, please wait...</p>
    </div>
    <iframe
      [src]="iframeUrl"
      width="100%"
      height="600"
      frameborder="0"
      (load)="isIframeLoading = false"
      style="display: block;">
    </iframe>

  </ng-container>
</p-dialog> -->


